import NotFoundMessage from '../components/NotFoundMessage';

const NotFoundPage = () => {
  return <NotFoundMessage />;
};

export default NotFoundPage;
